import { Box } from "@mui/material";
import styled from "styled-components";

export const Content = styled(Box)`
  padding: 20px 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const PaymentOptions = styled(Box)`
  display: flex;
  flex-direction: column;
`;
